module.exports = __webpack_public_path__ + "media/components/country-flag/static/cu-dbc0401f4801f86aa07f411347960c84.svg";